module.exports = __webpack_public_path__ + "static/media/piggyPlane.1f8a4d62.gif";